import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { FinanceKey } from './keys';

export const locales = {
  en,
  nl: nl as Record<FinanceKey, string>,
  ro: ro as Record<FinanceKey, string>,
} as const satisfies Partial<Record<LangCode, Record<FinanceKey, string>>> & {
  en: Record<FinanceKey, string>;
};
export type { FinanceKey } from './keys';
